import {
  GET_ALL_CARELABEL,
  GET_ALL_CARELABEL_GROUP,
  GET_CARELABEL_GROUP_ID,
  GET_ALL_TYPE_CARELABEL,
  GET_ALL_CARELABEL_GROUP_ID,
  UNMOUNT_CARE_GROUP,
  UNMOUNT_CARE_LIBRARY,
} from './CareLabel.type';

const initialState = {
  CareLibraryList: [],
  CareGropList: [],
  CareGropSingleData: null,
  AllCareLibraryList: [],
  careGroupFilterOption: [],
};
const BomTypeReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ALL_CARELABEL:
      return {
        ...state,
        CareLibraryList: action.payload,
      };
    case GET_ALL_CARELABEL_GROUP:
      return {
        ...state,
        CareGropList: action.payload,
      };
    case GET_CARELABEL_GROUP_ID:
      return {
        ...state,
        CareGropSingleData: action.payload,
      };
    case GET_ALL_TYPE_CARELABEL:
      return {
        ...state,
        AllCareLibraryList: action.payload,
      };
    case GET_ALL_CARELABEL_GROUP_ID:
      return {
        ...state,
        careGroupFilterOption: action.payload,
      };
    case UNMOUNT_CARE_GROUP:
      return {
        ...state,
        CareGropSingleData: null,
      };
    case UNMOUNT_CARE_LIBRARY:
      return {
        ...state,
        CareLibraryList: null,
      };
    default:
      return state;
  }
};

export default BomTypeReducer;
